import PropTypes from 'prop-types';

/**
 * 通用 Tab 切換組件
 *
 * @param {Array} tabs - Tab 陣列，格式：[{ key: 'tab1', label: '標籤1' }, ...]
 * @param {String} activeTab - 當前激活的 tab key
 * @param {Function} onChange - Tab 切換回調函數，傳入被點擊的 tab key
 * @param {String} className - 可選的額外類名
 * @param {Boolean} fill - 是否等寬平分整列（預設靠左排列）。w-100 讓每個 tab 的
 *                          flex-basis 一致，否則 flex-fill 只分剩餘空間，底線會不等長
 */
const Tabs = ({ tabs, activeTab, onChange, className = '', fill = false }) => {
  return (
    <div className={`d-flex gap-3 ${className}`}>
      {tabs.map((tab) => (
        <h5
          key={tab.key}
          className={`pb-2 mb-0 hover-p ${fill ? 'flex-fill w-100 text-center' : ''} ${activeTab === tab.key ? 'tab-active' : ''}`}
          onClick={() => onChange(tab.key)}
        >
          {tab.label}
        </h5>
      ))}
    </div>
  );
};

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  activeTab: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  fill: PropTypes.bool
};

export default Tabs;
